/**
 * EditShoppingCartSettingsCtrl controller
 * Edit shopping cart Settings
 */

/**
 * EditShoppingCartSettingsCtrl controller
 *
 * @class EditShoppingCartSettingsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:EditShoppingCartSettingsCtrl
 */
/* @ngInject */
export default function EditShoppingCartSettingsCtrl ($scope, $uibModalInstance, Subscription, alertLiteSvc, sc, networkId, error) {
  var vm = this
  vm.sc = sc

  vm.subscription = new Subscription({ networkId, id: sc.subscriptionId })

  vm.sc.labelEnabled = !!sc.promoLabel

  vm.ngQuillToolbar = {
    toolbar: [
      ['bold', 'underline', 'strike'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: ['', 'center', 'right'] }],
      ['image']
    ]
  }

  /**
   * Save Partner Program
   *
   * @memberof mwApp/partnerPrograms.controller:EditShoppingCartSettingsCtrl
   */
  vm.submit = function () {
    if (!sc.labelEnabled) {
      sc.promoLabel = ''
    }

    $uibModalInstance.close(sc)
  }

  /**
   * Upload logo
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return vm.subscription._uploadFile(null, file, {
      type
    }).data()
  }

  vm.uploadImage = (file) => {
    $scope.form.$setDirty()
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      _URL.revokeObjectURL(objectUrl)

      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (this.width * this.height > 16800000) {
        alertLiteSvc.alertError('Max resolution of image is 16.8MPx')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'subscription_shopping_cart')
        .then((url) => {
          vm.sc.coverImageUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/partnerPrograms.controller:EditShoppingCartSettingsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  $scope.$watch('vm.form', () => {
    if (error) {
      vm.form.heading.$setTouched()
    }
  })
}
